
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Table,
} from "reactstrap"
import { connect } from "react-redux"

//Import Action
import { setBreadcrumbItems } from "../../../store/actions"
import { getSalesStats } from "../../../helpers/fakebackend_helper"

const SalesDashboard = (props) => {
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const breadcrumbItems = [
            { title: "CRM", link: "#" },
            { title: "Dashboard", link: "#" },
            { title: "Commercial", link: "#" },
        ]
        props.setBreadcrumbItems("Tableau de Bord Commercial", breadcrumbItems)

        loadStats()
    }, [])

    const loadStats = async () => {
        try {
            const data = await getSalesStats()
            setStats(data)
            setLoading(false)
        } catch (error) {
            console.error("Error loading sales stats", error)
            setLoading(false)
        }
    }

    if (loading) {
        return <div className="text-center p-5">Chargement...</div>
    }

    return (
        <React.Fragment>
            <Row>
                <Col md="4">
                    <Card className="mini-stat bg-primary text-white">
                        <CardBody>
                            <div className="mb-4">
                                <div className="float-start mini-stat-img me-4">
                                    <i className="mdi mdi-account-clock font-size-24"></i>
                                </div>
                                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Essais Actifs</h5>
                                <h4 className="fw-medium font-size-24">{stats?.active_trials}</h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="4">
                    <Card className="mini-stat bg-danger text-white">
                        <CardBody>
                            <div className="mb-4">
                                <div className="float-start mini-stat-img me-4">
                                    <i className="mdi mdi-alert-circle-outline font-size-24"></i>
                                </div>
                                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Expirent Bientôt (3j)</h5>
                                <h4 className="fw-medium font-size-24">{stats?.expiring_trials_3_days}</h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="4">
                    <Card className="mini-stat bg-success text-white">
                        <CardBody>
                            <div className="mb-4">
                                <div className="float-start mini-stat-img me-4">
                                    <i className="mdi mdi-trending-up font-size-24"></i>
                                </div>
                                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Taux de Conversion</h5>
                                <h4 className="fw-medium font-size-24">{stats?.conversion_rate}</h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Inscriptions en Essai Gratuit Récents</CardTitle>
                            <div className="table-responsive">
                                <Table className="table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Entreprise</th>
                                            <th>Plan choisi</th>
                                            <th>Date de début</th>
                                            <th>Fin de l'essai</th>
                                            <th>Statut</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(stats?.recent_trials || []).map((subscription, key) => (
                                            <tr key={key}>
                                                <td>{subscription.company?.name}</td>
                                                <td>{subscription.plan?.name}</td>
                                                <td>{new Date(subscription.created_at).toLocaleDateString()}</td>
                                                <td>
                                                    <span className="text-danger fw-bold">
                                                        {new Date(subscription.trial_ends_at).toLocaleDateString()}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Badge color="warning" className="font-size-11">EN ESSAI</Badge>
                                                </td>
                                            </tr>
                                        ))}
                                        {(stats?.recent_trials || []).length === 0 && (
                                            <tr>
                                                <td colSpan="5" className="text-center p-4 italic text-muted">
                                                    Aucun essai gratuit actif pour le moment.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(SalesDashboard)
